import styled from "styled-components";
import theme from "../../styles/theme";

export const StyledFooter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: ${(props) => (props.isMobile ? "7.25rem" : "11.688rem")};
  background-color: ${theme.color.headerFooterBg};
`;

export const StyledFooterText = styled.div`
  display: flex;
  color: ${theme.color.white};
  margin-top: ${(props) => (props.isMobile ? "1.438rem" : "2.688rem")};
`;

export const StyledImg = styled.img`
  display: flex;
  max-width: 17.5rem;
  position: relative;
  top: 1rem;
`;
